module.exports = __webpack_public_path__ + "static/media/Janda Romantic-01.4aeb757f.svg";